import { Link } from 'react-router-dom';
import { siteNav } from '@/mocks/common';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="font-heading text-2xl font-bold text-primary-400 tracking-tight">BOB</span>
                <span className="text-sm text-foreground-400">体育</span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                bob体育是专业的在线体育娱乐平台，提供足球、篮球、网球等全球顶级赛事竞猜服务，实时赔率更新，安全可靠。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {siteNav.main.map((item) => (
                  <li key={item.href}>
                    <Link to={item.href} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-50 mb-4">热门赛事</h4>
              <ul className="space-y-2.5">
                <li><Link to="/category/football" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">足球竞猜</Link></li>
                <li><Link to="/category/basketball" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">篮球竞猜</Link></li>
                <li><Link to="/category/tennis" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">网球竞猜</Link></li>
                <li><Link to="/category/esports" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">电竞竞猜</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-customer-service-2-line text-primary-400"></i>
                  7×24小时在线客服
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-mail-line text-primary-400"></i>
                  service@bob-sports.com
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-phone-line text-primary-400"></i>
                  400-888-8888
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-foreground-800/30">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; 2026 bob体育 版权所有 | 18+ 理性投注
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">隐私政策</a>
                <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">服务条款</a>
                <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">责任博彩</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}